import { library } from '@fortawesome/fontawesome-svg-core'

import {
	faGauge,
	faPlus,
	faBuilding,
	faAddressBook,
	faCalendar,
	faCalendarDay,
	faClipboard,
	faFileLines,
	faChartLine,
	faCircleXmark,
	faTrash,
	faExclamationCircle,
	faClipboardCheck,
	faCircleLeft,
	faDesktop,
	faCircleInfo,
	faHouse,
	faTruck,
	faWeightHanging,
	faCircleArrowRight,
	faHand,
	faHelmetSafety,
	faComputer,
	faChevronRight,
	faNoteSticky,
	faMinus,
	faSave,
	faSquareCheck,
	faTruckArrowRight,
	faRocket,
	faCamera,
	faHourglass,
	faCircleHalfStroke,
	faCircle,
	faPencil,
	faArrowsRotate,
	faFilter,
	faKey,
	faWarehouse,
	faRoad,
	faRightFromBracket,
	faRightToBracket,
	faAngleLeft,
	faAngleRight,
	faTruckFront,
	faCheckCircle,
	faHome,
	faSignature,
	faPaperclip,
	faPhone,
	faMapPin,
	faMap,
	faRotateRight,
	faAngleDown,
	faAngleUp,
	faClockRotateLeft,
	faRoute,
	faMaximize,
	faMinimize,
	faTablet,
	faFolder,
	faMagnifyingGlass,
	faDownload,
	faExternalLink,
	faAnglesUp,
	faAnglesDown,
	faFileCirclePlus,
	faFilePen,
	faUpload,
	faFileArrowUp,
	faFile,
	faMapMarker,
	faEye,
	faEyeSlash,
	faSync,
	faSearch,
	faInbox,
	faChevronDown,
	faChevronUp,
	faTimes,
	faCheck,
	faInfoCircle,
	faExclamationTriangle,
	faClock,
	faPlusCircle,
	faFilePdf,
	faArrowUp,
	faArrowDown,
	faSquare,
	faCheckSquare,
	faExternalLinkAlt,
	faHourglassHalf,
	faTh,
	faList,
	faBoxes,
	faUpRightFromSquare,
	faEdit
} from '@fortawesome/free-solid-svg-icons'

import {
	faCheckCircle as farCheckCircle,
	faCircleXmark as farCircleXMark,
	faCircle as farCircle,
	faFile as farFile,
	faSquare as farSquare
} from '@fortawesome/free-regular-svg-icons'
import { faMailchimp } from '@fortawesome/free-brands-svg-icons'

const icons = library.add(
	faHourglass,
	faGauge,
	faPlus,
	faBuilding,
	faAddressBook,
	faCalendar,
	faCalendarDay,
	faClipboard,
	faFileLines,
	faChartLine,
	faCircleXmark,
	faFile,
	farFile,
	faTrash,
	faExclamationCircle,
	faClipboardCheck,
	faCircleLeft,
	faDesktop,
	faCircleInfo,
	faHouse,
	farCheckCircle,
	farCircleXMark,
	faTruck,
	faWeightHanging,
	faCircleArrowRight,
	faHand,
	faHelmetSafety,
	faComputer,
	faChevronRight,
	faNoteSticky,
	faMinus,
	faSave,
	faSquareCheck,
	faTruckArrowRight,
	faRocket,
	faCamera,
	faCircleHalfStroke,
	faCircle,
	farCircle,
	faPencil,
	faArrowsRotate,
	faFilter,
	faKey,
	faWarehouse,
	faRoad,
	faRightFromBracket,
	faRightToBracket,
	faAngleLeft,
	faAngleRight,
	faTruckFront,
	faCheckCircle,
	faPaperclip,
	faPhone,
	faMapPin,
	faMap,
	faHome,
	faCamera,
	faSignature,
	faRotateRight,
	faAngleDown,
	faAngleUp,
	faClockRotateLeft,
	faRoute,
	faMaximize,
	faMinimize,
	faTablet,
	faFolder,
	faMagnifyingGlass,
	faDownload,
	faExternalLink,
	faAnglesUp,
	faAnglesDown,
	faAngleDown,
	faClockRotateLeft,
	faRoute,
	faMaximize,
	faMinimize,
	faTablet,
	faMailchimp,
	faFileCirclePlus,
	faFilePen,
	faUpload,
	faFileArrowUp,
	faMapMarker,
	faEye,
	faEyeSlash,
	faSync,
	faSearch,
	faInbox,
	faChevronDown,
	faChevronUp,
	faTimes,
	faCheck,
	faInfoCircle,
	faExclamationTriangle,
	faClock,
	faPlusCircle,
	faFilePdf,
	faArrowUp,
	faArrowDown,
	faSquare,
	farSquare,
	faCheckSquare,
	faExternalLinkAlt,
	faHourglassHalf,
	faTh,
	faList,
	faBoxes,
	faUpRightFromSquare,
	faEdit
)

export default icons
